import QuestionTextProvider from "Components/CommonComponents/QuestionTextProvider";
import React from "react";

const QuestionPreviewComponent = ({ questionData }: any) => {
  const { text, choices } = questionData || {};
  const createChoiceId = (number: any) => {
    const alpha = 64;
    return String.fromCharCode(Number(number) + Number(alpha));
  };
  return (
    <div>
      <QuestionTextProvider content={text} />
      {choices?.map((choice: any, index: number) => (
        <div
          key={index}
          style={{ display: "flex", alignItems: "flex-start", gap: "8px" }}
        >
          <div style={{ fontWeight: "600" }}>{createChoiceId(index + 1)}.</div>
          <QuestionTextProvider content={choice?.text} />
        </div>
      ))}
    </div>
  );
};

export default QuestionPreviewComponent;
